// Partner pages that act on a partner's customers' services. Partner routes only
// allow a partner to act on records it owns, so when an admin is logged in as
// the partner these calls go to the matching admin/manage route instead, with
// the admin's own token.
export default {
  computed: {
    actingAdminToken() {
      const { adminUser } = this.$store.state;
      return adminUser && adminUser.auth_token ? adminUser.auth_token : null;
    },
  },
  methods: {
    managedPath(path) {
      return this.actingAdminToken ? path.replace(/^partner\//, 'admin/manage/') : path;
    },
    managedConfig() {
      if (!this.actingAdminToken) {
        return {};
      }

      return { headers: { Authorization: `Basic ${window.btoa(this.actingAdminToken)}` } };
    },
    managedPost(path, data) {
      return this.$api.post(this.managedPath(path), data, this.managedConfig());
    },
    managedDelete(path) {
      return this.$api.delete(this.managedPath(path), this.managedConfig());
    },
  },
};
